// Must match ROLE_NAMES in backend/helpers/src/roles.ts
export const ROLE_NAMES = {
  PATIENT: 'Paciente',
  PROFESSIONAL: 'Profesional',
  PHARMACY: 'Farmacia',
} as const;

export type RoleName = (typeof ROLE_NAMES)[keyof typeof ROLE_NAMES];

// Where to send a user right after login, or when they land on a route their
// role can't use.
export const getRoleHomePath = (role: string | null): string => {
  switch (role) {
    case ROLE_NAMES.PROFESSIONAL:
      return '/prescription/history';
    case ROLE_NAMES.PATIENT:
      return '/medication/mine';
    case ROLE_NAMES.PHARMACY:
      return '/pharmacy/dispensing';
    default:
      return '/auth/login';
  }
};

interface RoleGatedItem {
  roles?: string[];
  children?: RoleGatedItem[];
  [key: string]: any;
}

// Drops menu items the current role can't see. A group with no `roles` of
// its own is kept only if at least one of its children survives filtering.
export const filterByRole = <T extends RoleGatedItem>(items: T[], role: string | null): T[] =>
  items.reduce<T[]>((visible, item) => {
    if (item.roles && (!role || !item.roles.includes(role))) return visible;

    if (item.children) {
      const children = filterByRole(item.children, role);
      if (children.length === 0) return visible;
      visible.push({ ...item, children });
    } else {
      visible.push(item);
    }

    return visible;
  }, []);
